import { initializeApp } from "firebase/app";
import {
  getAuth,
  signInWithPopup,
  signOut,
  GoogleAuthProvider,
  UserCredential,
  onAuthStateChanged,
} from "firebase/auth";
import {
  getFirestore,
  query,
  getDocs,
  collection,
  where,
  addDoc,
} from "firebase/firestore";
import { getStorage, ref } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyChfUG3lwUEGJgw746krnz37CDPtFTMEss",
  authDomain: "funko-pop-store.firebaseapp.com",
  projectId: "funko-pop-store",
  storageBucket: "funko-pop-store.appspot.com",
  messagingSenderId: "578629507998",
  appId: "1:578629507998:web:c9b0d792922310ed1ad48f",
  measurementId: "G-1CLM8R49J7",
};
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);
const googleProvider = new GoogleAuthProvider();
const storage = getStorage(app);
// const storageRef = ref(storage);
const signInWithGoogle = async () => {
  try {
    const res = await signInWithPopup(auth, googleProvider);
    const user = res.user;
    const q = query(collection(db, "users"), where("uid", "==", user.uid));
    const docs = await getDocs(q);
    if (docs.docs.length === 0) {
      await addDoc(collection(db, "users"), {
        uid: user.uid,
        name: user.displayName,
        authProvider: "google",
        email: user.email,
      });
    }
    return user;
  } catch (err: any) {
    console.error(err);
  }
};

const logoutFirebase = () => {
  signOut(auth);
};

const getCurrentUser = () => {
  return auth.currentUser;
};

export {
  // storageRef,
  storage,
  auth,
  db,
  signInWithGoogle,
  logoutFirebase,
  getCurrentUser,
  onAuthStateChanged,
};
